import {
  Box,
  Tab,
  Tabs,
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import React, { useState } from "react";
import { TravelAssistanceStyles } from "../Styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";

import HpImg1 from "../../assets/Banner/HomeApplianceBanner/HP1.png";
import HpImg2 from "../../assets/Banner/HomeApplianceBanner/HP2.png";
import HpImg3 from "../../assets/Banner/HomeApplianceBanner/HP1.png";
import BackgroundImg1 from "../../assets/Banner/MobileProtectionBanner/MP1.png";
import BackgroundImg2 from "../../assets/Banner/MobileProtectionBanner/MP2.png";
import BackgroundImg3 from "../../assets/Banner/MobileProtectionBanner/MP3.png";
import blogBackground from "../../assets/images/Home/Blog.png";

import Claims from "../../assets/icons/Claims.png";
import PickUp from "../../assets/icons/PickUp.png";
import Delivery from "../../assets/icons/Delivery.png";
import PhoneRepair from "../../assets/icons/PhoneRepair.png";

import Heading from "../../components/Heading";
import { GadgetsProtectionStyles } from "../Styles";
import StepCard from "../../components/Gadgets/StepCard";
import PlanCard from "../../components/Gadgets/PlanCard";
import RatingCard from "../../components/Gadgets/RatingCard";
import GlobalSubHeading from "../../components/GlobalSubHeading";
import TestimonialCard from "../../components/Gadgets/Testimonial";
import BannerCarousel from "../../components/Gadgets/BannerCarousel";
import VideoTestimonial from "../../components/Gadgets/VideoTestimonial";

const MOBILEPLANS = [
  {
    title: "One-Time Screen Replacement",
    customers: "Chosen by 90,796 customers in last 30 days",
    features: [
      "ccidents happen — we've got you covered. If your device screen gets damaged, we'll replace it once at no extra cost.",
      "Available for both new and existing devices.",
    ],
    image: "/path/to/image1.png", // Replace with actual path
  },
  {
    title: "Extended Warranty",
    customers: "Chosen by 59,760 customers in last 30 days",
    features: [
      "Enjoy peace of mind beyond the standard warranty. We cover your device against all kinds of malfunction issues — from speaker problems to general hardware and software repairs. ",
      "Reliable support whenever you need it. ",
    ],
    image: "/path/to/image2.png",
  },
  {
    title: "Accidental & Liquid Damage",
    customers: "Chosen by 30,760 customers in last 30 days",
    features: [
      "Life is unpredictable, but your device protection doesn’t have to be. We cover repair costs for accidental drops and spills. Whether it’s a cracked screen from a fall or damage from liquid.",
      "Full coverage for future mishaps.",
    ],
    image: "/path/to/image3.png",
    isNew: true,
  },
];
const HOMEAPPLIANCEPLANS = [
  {
    title: "Damage Protection Plan",
    customers: "Chosen by 90,796 customers in last 30 days",
    features: [
      "Cover cost of future damages due to accidents!",
      "Cover cost due to liquid damages e.g water spills!",
    ],
    image: "/path/to/image1.png", // Replace with actual path
  },
  {
    title: "Extended Warranty ",
    customers: "Chosen by 59,760 customers in last 30 days",
    features: [
      "Professional at-home repairs by certified technicians.",
      "Coverage for electrical and mechanical failures, including components like motors, compressors, and control panels",
    ],
    image: "/path/to/image2.png",
  },
  {
    title: "Annual Maintenance Contract (AMC)",
    customers: "Chosen by 30,760 customers in last 30 days",
    features: [
      "Scheduled preventive maintenance services, such as AC gas refilling, washing machine pump checks, etc.",
      "Timely servicing to prevent unexpected breakdowns.",
    ],
    image: "/path/to/image3.png",
    isNew: true,
  },
];

const GadgetProtection = () => {
  const [formData, setFormData] = useState({
    brand: "",
    purchaseDate: "",
    amount: "",
  });

  const MPBannerImages = [BackgroundImg1, BackgroundImg2, BackgroundImg3];
  const HomeApplianceBannerImages = [HpImg1, HpImg2, HpImg3];

  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const FeatureItem = ({ text }) => (
    <Stack direction="row" alignItems="center" spacing={1}>
      <CheckCircleIcon color="success" />
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          textAlign: "left",
          fontFamily: '"Poppins", serif',
          fontSize: { xs: "0.8rem", sm: "1rem", md: "1.2rem" },
        }}
      >
        {text}
      </Typography>
    </Stack>
  );

  const Stat = ({ icon, label, sub }) => (
    <Stack alignItems="center">
      {icon}
      <Typography
        variant="h6"
        fontWeight={700}
        sx={{ fontFamily: '"Poppins", serif' }}
      >
        {label}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontFamily: '"Poppins", serif' }}
      >
        {sub}
      </Typography>
    </Stack>
  );

  return (
    <Box sx={GadgetsProtectionStyles.BackgroundBox(blogBackground)}>
      <Box mt={10} sx={[TravelAssistanceStyles.MainBannerBox]}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          aria-label="Gadget Protection Tabs"
          textColor="primary"
          indicatorColor="primary"
          centered
          sx={{ mb: 2 }}
        >
          <Tab
            label="Mobile Protection"
            sx={GadgetsProtectionStyles.TabStyle}
          />
          <Tab label="Home Appliances" sx={GadgetsProtectionStyles.TabStyle} />
        </Tabs>

        {tabIndex === 0 && (
          <Box sx={{ padding: "20px 0px" }}>
            {/* ****** Banner Container *******/}
            <Box sx={{ mt: { xs: 2, sm: 2, md: 2, lg: 2 } }}>
              <BannerCarousel images={MPBannerImages} />
            </Box>

            <Grid
              container
              spacing={4}
              display="flex"
              alignItems="center"
              justifyContent="space-around"
              sx={{ mt: { xs: 3, sm: 3, md: 6, lg: 6 } }}
            >
              {/* Left Section */}
              <Grid item xs={12} md={5} sx={{ width: "400px" }}>
                <Box>
                  <Heading
                    title={"Trust only the best for Protecting your Mobiles"}
                  />
                </Box>

                <Stack spacing={0} mt={3}>
                  <FeatureItem text="Protection from damages, liquid spills and defects" />
                  <FeatureItem text="Mobile protection plans start at only Rs.3/day*" />
                  <FeatureItem text="100% genuine service. 0% hassle" />
                </Stack>

                <Stack direction="row" spacing={6} mt={4}>
                  <Stat
                    icon={<EmojiEventsIcon color="primary" />}
                    label="12 years"
                    sub="of expertise"
                  />
                  <Stat
                    icon={<EmojiEmotionsIcon color="primary" />}
                    label="5 Million+"
                    sub="Happy Customers"
                  />
                </Stack>
              </Grid>

              {/* Right Section */}
              <Grid item xs={12} md={7} sx={{ width: "400px" }}>
                <Box
                  sx={{
                    p: 4,
                    boxShadow: 3,
                    borderRadius: 2,
                    backgroundColor: "white",
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight={600}
                    mb={3}
                    textAlign="left"
                    fontFamily='"Poppins", serif'
                  >
                    Find plans for your device
                  </Typography>

                  <Stack spacing={2}>
                    <TextField
                      fullWidth
                      label="Device Brand"
                      variant="outlined"
                      name="brand"
                      value={formData.brand}
                      onChange={handleChange}
                      sx={GadgetsProtectionStyles.TextFieldStyle}
                    />

                    <TextField
                      fullWidth
                      label="Purchase date"
                      variant="outlined"
                      name="purchaseDate"
                      value={formData.purchaseDate}
                      onChange={handleChange}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <CalendarTodayIcon />
                          </InputAdornment>
                        ),
                      }}
                      sx={GadgetsProtectionStyles.TextFieldStyle}
                    />

                    <TextField
                      fullWidth
                      label="How much did you purchase it for?"
                      variant="outlined"
                      name="amount"
                      value={formData.amount}
                      onChange={handleChange}
                      sx={GadgetsProtectionStyles.TextFieldStyle}
                    />

                    <Button
                      variant="contained"
                      size="large"
                      sx={GadgetsProtectionStyles.FindPlansButton}
                      fullWidth
                    >
                      Find Plans
                    </Button>
                  </Stack>
                </Box>
              </Grid>
            </Grid>

            {/* ****** Plan Heading Container *******/}
            <Box textAlign="center" mb={3} mt={5}>
              <Heading title={"Let's find you the best plan"} />
              <GlobalSubHeading subTitle="Quick. Convenient. Best value-for-money protection plan." />
            </Box>

            {/* ****** Plan Card Container *******/}
            <Box sx={GadgetsProtectionStyles.CenteredBox}>
              <Grid
                container
                spacing={2}
                mb={5}
                sx={GadgetsProtectionStyles.GridCentered}
              >
                {MOBILEPLANS.map((plan, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <PlanCard {...plan} />
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* ****** Claim Container *******/}
            <Box mb={2}>
              <Heading title="Hassle-free and convenient claim process" />
            </Box>

            <Grid
              container
              spacing={4}
              sx={GadgetsProtectionStyles.GridCentered}
            >
              <Grid item xs={12} sm={6} md={3}>
                <StepCard
                  step={1}
                  title="Claim in Minutes"
                  description="Call or email us — we’ll handle the rest."
                  icon={
                    <img
                      src={Claims}
                      alt="Step Icon"
                      style={{ width: 100, height: 100 }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StepCard
                  step={2}
                  title="Doorstep Pickup"
                  description="We’ll collect your device. No stress, no hassle."
                  icon={
                    <img
                      src={PickUp}
                      alt="Step Icon"
                      style={{ width: 100, height: 100 }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StepCard
                  step={3}
                  title="Pro Repair"
                  description="Certified experts restore your device to perfection.."
                  icon={
                    <img
                      src={PhoneRepair}
                      alt="Step Icon"
                      style={{ width: 100, height: 100 }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StepCard
                  step={4}
                  title="Swift Return"
                  description="Your device, as good as new, delivered to you."
                  icon={
                    <img
                      src={Delivery}
                      alt="Step Icon"
                      style={{ width: 100, height: 100 }}
                    />
                  }
                />
              </Grid>
            </Grid>

            {/* ****** Rating Section ****** */}
            <Box mt={7}>
              <Heading title="Everything that we do is designed around you" />
            </Box>
            <RatingCard />

            {/* ****** Video Testimonial Container ****** */}
            <Grid container spacing={4} mt={4}>
              <Grid
                item
                xs={12}
                md={12}
                sx={GadgetsProtectionStyles.GridCentered}
              >
                <VideoTestimonial />
              </Grid>
            </Grid>

            {/* ****** Testimonial Cards Container ****** */}
            <Grid mt={3} item xs={12} sm={6} md={4}>
              <Grid
                container
                spacing={4}
                sx={GadgetsProtectionStyles.GridCentered}
              >
                <Grid item xs={12} sm={6} md={3}>
                  <TestimonialCard
                    isImg={true}
                    initials={require("../../assets/images/User/Manya.png")}
                    name="Manya"
                    rating={5}
                    review="Quick claim, impressive service. Grateful for prompt support!"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TestimonialCard
                    isImg={true}
                    initials={require("../../assets/images/User/Shivani.png")}
                    name="Shivani"
                    rating={5}
                    review="Swift claim, excellent service, highly recommended!"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TestimonialCard
                    isImg={true}
                    initials={require("../../assets/images/User/Ankur.jpeg")}
                    name="Ankur"
                    rating={5}
                    review="Hassle-free insurance process, professional handling!"
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TestimonialCard
                    initials="AK"
                    name="Akash"
                    rating={5}
                    review="Phone restored, very satisfied, highly recommended!"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
        )}

        {tabIndex === 1 && (
          <Box sx={{ padding: "20px 0px" }}>
            {/* ****** Banner Container *******/}
            <Box sx={{ mt: { xs: 2, sm: 0, md: 0, lg: 0 } }}>
              <BannerCarousel images={HomeApplianceBannerImages} />
            </Box>

            <Grid
              container
              spacing={4}
              display="flex"
              alignItems="center"
              justifyContent="space-around"
              sx={{ mt: { xs: 3, sm: 3, md: 6, lg: 6 } }}
            >
              {/* Left Section */}
              <Grid item xs={12} md={5} sx={{ width: "400px" }}>
                <Box>
                  <Heading
                    title={"Trust only the best for Protecting your Appliances"}
                  />
                </Box>

                <Stack spacing={0} mt={3}>
                  <FeatureItem text="Professional in-home repairs by expert technicians" />
                  <FeatureItem text="Annual maintenance plans to keep appliances running like new" />
                  <FeatureItem text="100% genuine parts. 0% hidden costs" />
                </Stack>

                <Stack direction="row" spacing={6} mt={4}>
                  <Stat
                    icon={<EmojiEventsIcon color="primary" />}
                    label="12 years"
                    sub="of expertise"
                  />
                  <Stat
                    icon={<EmojiEmotionsIcon color="primary" />}
                    label="5 Million+"
                    sub="Happy Customers"
                  />
                </Stack>
              </Grid>

              {/* Right Section */}
              <Grid item xs={12} md={7} sx={{ width: "400px" }}>
                <Box
                  sx={{
                    p: 4,
                    boxShadow: 3,
                    borderRadius: 2,
                    backgroundColor: "white",
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight={600}
                    mb={3}
                    textAlign="left"
                    fontFamily='"Poppins", serif'
                  >
                    Find plans for your device
                  </Typography>

                  <Stack spacing={2}>
                    <TextField
                      fullWidth
                      label="Device Brand"
                      variant="outlined"
                      name="brand"
                      value={formData.brand}
                      onChange={handleChange}
                      sx={GadgetsProtectionStyles.TextFieldStyle}
                    />

                    <TextField
                      fullWidth
                      label="Purchase date"
                      variant="outlined"
                      name="purchaseDate"
                      value={formData.purchaseDate}
                      onChange={handleChange}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <CalendarTodayIcon />
                          </InputAdornment>
                        ),
                      }}
                      sx={GadgetsProtectionStyles.TextFieldStyle}
                    />

                    <TextField
                      fullWidth
                      label="How much did you purchase it for?"
                      variant="outlined"
                      name="amount"
                      value={formData.amount}
                      onChange={handleChange}
                      sx={GadgetsProtectionStyles.TextFieldStyle}
                    />

                    <Button
                      variant="contained"
                      size="large"
                      sx={GadgetsProtectionStyles.FindPlansButton}
                      fullWidth
                    >
                      Find Plans
                    </Button>
                  </Stack>
                </Box>
              </Grid>
            </Grid>

            {/* ****** Plan Heading Container *******/}
            <Box textAlign="center" mb={3} mt={5}>
              <Heading title={"Let's find you the best plan"} />
              <GlobalSubHeading subTitle="Quick. Convenient. Best value-for-money protection plan." />
            </Box>

            {/* ****** Plan Card Container *******/}
            <Box sx={GadgetsProtectionStyles.CenteredBox}>
              <Grid
                container
                spacing={2}
                mb={5}
                sx={GadgetsProtectionStyles.GridCentered}
              >
                {HOMEAPPLIANCEPLANS.map((plan, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <PlanCard {...plan} />
                  </Grid>
                ))}
              </Grid>
            </Box>

            {/* ****** Claim Container *******/}
            <Box mb={2}>
              <Heading title="Hassle-free and convenient claim process" />
            </Box>

            <Grid
              container
              spacing={4}
              sx={GadgetsProtectionStyles.GridCentered}
            >
              <Grid item xs={12} sm={6} md={3}>
                <StepCard
                  step={1}
                  title="Claim in Minutes"
                  description="Call or email us — we’ll handle the rest."
                  icon={
                    <img
                      src={Claims}
                      alt="Step Icon"
                      style={{ width: 100, height: 100 }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StepCard
                  step={2}
                  title="Doorstep Pickup"
                  description="Sit back and relax as we pick up the device from your doorstep"
                  icon={
                    <img
                      src={PickUp}
                      alt="Step Icon"
                      style={{ width: 100, height: 100 }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StepCard
                  step={3}
                  title="Pro Repair"
                  description="Certified experts restore your device to perfection."
                  icon={
                    <img
                      src={PhoneRepair}
                      alt="Step Icon"
                      style={{ width: 100, height: 100 }}
                    />
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StepCard
                  step={4}
                  title="Swift Return"
                  description="Free delivery of your repaired device at your doorstep"
                  icon={
                    <img
                      src={Delivery}
                      alt="Step Icon"
                      style={{ width: 100, height: 100 }}
                    />
                  }
                />
              </Grid>
            </Grid>

            {/* ****** Rating Section ****** */}
            <Box mt={7}>
              <Heading title="Everything that we do is designed around you" />
            </Box>
            <RatingCard />

            {/* ****** Video Testimonial Container ****** */}
            <Grid container spacing={4} mt={4}>
              <Grid
                item
                xs={12}
                md={12}
                sx={GadgetsProtectionStyles.GridCentered}
              >
                <VideoTestimonial />
              </Grid>
            </Grid>

            {/* ****** Testimonial Cards Container ****** */}
            <Grid mt={3} item xs={12} sm={6} md={4}>
              <Grid
                container
                spacing={4}
                sx={GadgetsProtectionStyles.GridCentered}
              >
                <Grid item xs={12} sm={6}>
                  <TestimonialCard
                    initials="AY"
                    name="Arjun Yadav"
                    rating={5}
                    review="Quick claim, impressive service. Grateful for prompt support!"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TestimonialCard
                    initials="PB"
                    name="Preeti Bajaj"
                    rating={5}
                    review="Swift claim, excellent service, highly recommended!"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TestimonialCard
                    initials="SS"
                    name="Sidharth Saxena"
                    rating={5}
                    review="Hassle-free insurance process, professional handling!"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TestimonialCard
                    initials="SL"
                    name="Shruti Lal"
                    rating={5}
                    review="Phone restored, very satisfied, highly recommended!"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default GadgetProtection;
// 858 Lines
